import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateRedirect($data: CreateRedirectInput!) {
    createRedirect(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createRedirect: {
    id: number;
  };
}
